import './movie-detail.scss';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/styles';
import { useDispatch, useSelector } from 'react-redux';
import movieDetailAction from '../../../store/actions/movie.action';
import { getLocalStorage, makeFinalRequest, setTitle } from '../../../shared/services/general/general-service';
import Loading from '../../../components/loading/item-loading/loading';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import ImageGenerator from '../../../components/image-generator/image-generator';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Box from '@material-ui/core/Box';
import Promotion from '../../../components/promotion/promotion';
import favListAdd from '../../../assets/images/bookmark.svg';
import play from '../../../assets/images/play.svg';
import like from '../../../assets/images/like.svg';
import dislike from '../../../assets/images/dislike.svg';
import share from '../../../assets/images/share.svg';
import Subtract from '../../../assets/images/Subtract.svg';
import voice from '../../../assets/images/voice.svg';
import subTitle from '../../../assets/images/subTitle.svg';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { variable_names } from '../../../shared/services/general/configs';
import { addToFavorite, checkUserIsLogin, dislikeProgram, likeProgram, removeFromFavorite } from '../../../shared/services/user/user-service';
import Toast from '../../../components/toast/toast';
import { ShowToast, toastTypes } from '../../../components/toast/show-tosat';
import AuthenticationDialogHandler from '../../../components/authentication-dialog-handler/authentication-dialog-handler';
import ShareBottomSheet from '../../../components/bottom-sheet/share/share';
import { IconButton } from '@material-ui/core';
import '../../../assets/iamges/Subtract.svg';
import { Helmet } from 'react-helmet';
import { ArrowForwardIos } from '@material-ui/icons';
import imdb from '../../../assets/images/imdb.svg';
import heart from '../../../assets/images/Heart.svg';
import { ChevronRight } from '@material-ui/icons';
import download from '../../../assets/images/download.svg';
import Footer from '../../../components/footer/footer';
import ProgramCarousel from '../../../components/carousel/program/program-carousel';
import { useConfigApp } from '../../../shared/services/general/app-context';
import Breadcrumb from '../../../components/breadcrumb/breadcrumb';
import { useSeo } from '../../../shared/services/general/seoManager';
import defaultLogo from '../../../assets/images/bebin-logo.svg';
import { rateAProgram } from '../../../shared/services/more-page/more-page-service';
import { Rating } from '@material-ui/lab';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import Comments from '../../../components/comments/comments';
import SkeletonLoader from '../../../components/skeleton-loader/skeleton-loader';

const FixedCoverImage = styled.div`
  background-image: url(${props => props.image});
`;

const useStyles = makeStyles(() => ({
	main_image                   : {
		position: 'absolute',
		width: '184px',
		height: '268px',
		borderRadius: '5px',
		overflow: 'hidden',
		top: '-176px',
		left: 'calc(50% - 93px)',
	},
	main_image_after_scroll      : {
		display: 'none'
	},
	first_view_title             : {
		textAlign : 'center',
		fontSize  : '20px',
		fontWeight: 'bold'
	},
	title_after_scroll           : {
		display: 'none'
	},
	fixed_header_before_scroll   : {
		backgroundImage: 'none !important'
	},
	fixed_header_after_scroll    : {
		position: 'fixed',
		top     : '0',
		width   : '100%',
		height  : '215px',
		zIndex  : '1'
	},
	header_scrolling             : {
		position            : 'absolute',
		bottom              : '0',
		width               : '100%',
		backgroundColor     : 'white',
		borderTopRightRadius: '16px',
		borderTopLeftRadius : '16px',
		border              : '1px solid #c3c3c3',
		paddingTop          : '12px'
	},
	header_scrolling_before_title: {
		display: 'none'
	},
	header_scrolling_after_title : {
		display       : 'flex',
		position      : 'absolute',
		top           : '-50px',
		fontSize      : '30px',
		fontWeight    : 'bold',
		width         : '100%',
		justifyContent: 'center'
	},
	other_info_show              : {
		paddingTop: '140px'
	}
	
}));

function MovieDetailPage (props) {
	const { movieData, isLoad }                       = useSelector(state => state.movieDetail);
	const [scrollTop, setScrollTop]                   = useState(0);
	const classes                                     = useStyles();
	const [state, setState]                           = useState({
		top   : false,
		left  : false,
		bottom: false,
		right : false
	});
	const [drawerType, setDrawerType]                 = useState('');
	const history                                     = useHistory();
	const dispatch                                    = useDispatch();
	const [toastData, setToastData]                   = useState([]);
	const [openProfileDialog, setOpenProfileDialog]   = useState(false);
	const [openRegisterDialog, setOpenRegisterDialog] = useState(false);

	const [downloadLinks,setDownloadLinks]				= useState([]);
	const [showDownloadBox, setShowDownloadBox]   = useState(false);
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 980);
	const [relatedPrograms,setRelatedPrograms]	= useState();
	const [fromDirector,setFromDirector]			= useState();
	const configApp = useConfigApp();
	const { setSeoData } = useSeo();
	const [logo, setLogo] = useState([]);
	const [rateValue, setRateValue] = useState(null);
	const location = useLocation();
	const path = location.pathname;
	const [isRating, setIsRating]                   = useState(true);


	useEffect(() => {
		if (configApp) {
			const imgLogo = configApp?.logo ? require(`../../../../src/assets/images/${configApp?.logo}`).default : defaultLogo;
			setLogo(imgLogo)
		}
	}, [configApp]);

	useEffect(() => {
		const handleResize = () => {
			setIsDesktop(window.innerWidth > 980);
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		setSeoData({
			title: `${movieData?.baseDetails?.title} | ${configApp?.title}`,
			image: movieData?.baseDetails?.image,
			description: movieData?.baseDetails?.description,
		});
	}, [movieData, configApp]);

	const [isWebView, setIsWebView] = useState(false);

	useEffect(() => {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;

		// Android WebView
		const isAndroidWebView = /wv/.test(userAgent) && /Android/.test(userAgent);

		// iOS WebView
		const isIOSWebView = /iPhone|iPod|iPad/.test(userAgent) && !window.MSStream && !window.indexedDB;

		if (isAndroidWebView || isIOSWebView) {
			setIsWebView(true);
		}
	}, []);

	const getMovieDetails = async () => {
		const httpRequest              = new XMLHttpRequest();
		httpRequest.onreadystatechange = function () {
			if (this.readyState === 4) {
				if (this.status === 200) {
					const data = JSON.parse(httpRequest.response);
					let downloadLinksObject = data.data.movie.metadata.downloadLinks || null;

					let temp = [];
					for (const key in downloadLinksObject) {
						if (Object.hasOwnProperty.call(downloadLinksObject, key)) {
							const link = downloadLinksObject[key];
							// if (link!==""){
							// 	const updateLink = link.replace(/mediaId=[^&]*/, `mediaId=${configApp.media_id}`);
							// 	temp.push({link:updateLink,size:key.replace(/_/g, '')})
							// }

							if (link !== '') {
								if (configApp && configApp?.media_id) {
									const updateLink = link.replace(/mediaId=[^&]*/, `mediaId=${configApp?.media_id}`);
									temp.push({ link: updateLink, size: key.replace(/_/g, '') });
								} else {
									console.error('configApp یا media_id موجود نیست.');
									temp.push({ link: link, size: key.replace(/_/g, '') });
								}
							}
						}
					}
					setDownloadLinks(temp);
					dispatch(movieDetailAction(data.data.movie, props.match.params.id));
				} else if (this.status === 401) {
					localStorage.removeItem(variable_names.token);

					// ارسال مجدد درخواست
					getMovieDetails();
				}
			}
		};
		httpRequest.open('GET', makeFinalRequest(`page/${props.match.params.id}`, {}, 1), true);
		if (checkUserIsLogin()) {
			httpRequest.setRequestHeader('X-USER-TOKEN', getLocalStorage(variable_names.token, true));
		}
		httpRequest.send();
	};

	useEffect(() => {
		if (movieData?.userInteractions && movieData?.userInteractions?.rate && +movieData?.userInteractions?.rate > 0) {
			setRateValue(+movieData?.userInteractions?.rate)
		}
	}, [movieData]);

	useEffect(() => {
		if (configApp) {
			dispatch(movieDetailAction(null, props.match.params.id));
			getMovieDetails();
		}
	}, [configApp, path]);

	useEffect(() => {
		if (isLoad) {
			setTitle('فیلم سینمایی ' + movieData.baseDetails.title + ` | ${configApp?.title}`);

			if (movieData.relatedPrograms) {
				const updatedRelatedPrograms = {
					...movieData.relatedPrograms,
					objects: movieData.relatedPrograms?.items,
				};
				delete updatedRelatedPrograms?.items;
				setRelatedPrograms(updatedRelatedPrograms)

			}

			if (movieData.moreFromDirector) {
				const updatedFromDirector = {
					...movieData.moreFromDirector,
					objects: movieData?.moreFromDirector?.items,
				};
				delete updatedFromDirector?.items;
				setFromDirector(updatedFromDirector)
			}


		}
	}, [movieData, isLoad]);

	if (!isLoad) {
		return (
			<div className="movie-detail-container">
				<div className="movie-page">
					<div className="desktop-view">
						<div className="promotion-banner">
							<div className="promotion-box">
								<div className="promotion-info">
									<div className="d-flex flex-column">
										<div className="d-flex" style={{ gap: '30px', marginTop: '10px' }}>
											<SkeletonLoader type="text" count={1} width="70px" height="15px" />
											<SkeletonLoader type="text" count={1} width="70px" height="15px" />
											<SkeletonLoader type="text" count={1} width="70px" height="15px" />
										</div>
										<br />
										<div className="d-flex">
											<div className="right">
												<div>
													<SkeletonLoader type="rectangle" count={1} width="196px"
																	height="290px" />
												</div>
											</div>
											<div className="left">
												<div className="d-flex w-100">
													<div className="top-content">
														<SkeletonLoader type="text" count={1} width="400px"
																		height="15px" />
														<div style={{ marginBottom: '8px' }}></div>
														<div className="english-title">
															<SkeletonLoader type="text" count={1} width="235px"
																			height="12px" />
														</div>
														<div className="d-flex"
															 style={{ gap: '10px', marginTop: '23px' }}>
															<SkeletonLoader type="rectangle" count={1} width="73px"
																			borderRadius="20px"
																			height="26px" />
															<SkeletonLoader type="rectangle" count={1} width="73px"
																			borderRadius="20px"
																			height="26px" />
														</div>
													</div>
												</div>
												<br />
												<div className="d-flex" style={{ gap: '15px' }}>
													<SkeletonLoader type="rectangle" count={1} width="30px"
																	borderRadius="16px"
																	height="30px" />
													<SkeletonLoader type="rectangle" count={1} width="30px"
																	borderRadius="16px"
																	height="30px" />
												</div>
												<div className="description">
													<SkeletonLoader type="text" count={1} width="470px" height="10px" />
													<SkeletonLoader type="text" count={1} width="255px" height="10px" />
												</div>

												<div className="d-flex" style={{ gap: '15px' }}>
													<SkeletonLoader type="rectangle" count={1} width="250px"
																	borderRadius="16px"
																	height="44px" />
													<SkeletonLoader type="rectangle" count={1} width="250px"
																	borderRadius="16px"
																	height="44px" />
												</div>
												<div style={{ marginBottom: '46px' }}></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div style={{ position: 'relative', overflow: 'hidden' }}>
							<div className="main-title download-box-entry"
								 style={{ marginTop: '29px', marginBottom: '32px' }}>
							<span className="title">
								<SkeletonLoader type="text" count={1} width="55px" height="25px" />
							</span>
							</div>
							<div className="download-box">
								<div className="download-box-details show">
									<div className="All_buttons" style={{display: 'block'}}>
										<SkeletonLoader type="rectangle" count={1} width="100" height="68px"
														borderRadius="16px" />
										<span style={{ marginBottom: '19px', display: 'block' }}></span>
										<SkeletonLoader type="rectangle" count={1} width="100" height="68px"
														borderRadius="16px" />
										<span style={{ marginBottom: '19px', display: 'block' }}></span>
										<SkeletonLoader type="rectangle" count={1} width="100" height="68px"
														borderRadius="16px" />
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		)
	}

	const toggleDrawer = (anchor, open, drawer_type) => (event) => {
		if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
			return;
		}
		setState({ ...state, [anchor]: open });
		setDrawerType(drawer_type);
	};

	const renderTags = (media) => {
		const renderImdbRate = () => {
			if (media?.imdbRate) {
				return (
					<>
						<div className="rate">
						<span className="d-flex flex-column justify-content-center" style={{ alignItems: 'center' }}>
							<ImageGenerator src={imdb} />
							<span style={{ color: '#FFC63C' }}>{media?.imdbRate}</span>
						</span>
						</div>
					</>
				);
			}
			return null;
		};

		const renderProducedYear = () => {
			return (
				<div className="text-center">{media?.productionYear ? <span>{media.productionYear}</span> : null}</div>
			);
		};

		const renderCountry = () => {
			return (
				<div className="product-country">
					{
						media?.countries?.map((item) => item).join(' ، ')
					}
				</div>
			);
		};

		return (
			<>
				<Helmet>
					<title>{movieData.baseDetails.title}</title>
					<meta name="description" content={movieData.baseDetails?.description} />
				</Helmet>
				<div className="movie-other-info">
					{renderImdbRate()}
					<div className="pipe-line">
						{renderRateUsers()}
					</div>
					<div className="d-flex flex-column justify-content-center pipe-line">
						{renderCountry()}
						{renderProducedYear()}
					</div>
					{media?.isDubbed ? <>
						<div className="pipe-line isDubbed">
							<ImageGenerator src={voice}
											isLazy={false}
											name={''} />
							<span>دوبله شده</span>
						</div>
					</> : null}
					{media?.hasSubtitle ? <>
						<div className="pipe-line subTitle">
							<ImageGenerator src={subTitle}
											isLazy={false}
											name={''} />
							<span>زیرنویس</span>
						</div>
					</> : null}
					{media?.pg ? <>
						<span className="pipe">|</span>
						<div className="">
							<span>{media?.pg[0]?.bindings?.age || media?.pg[0]?.fields.age} +</span>
						</div>
					</> : null}
				</div>
			</>
		);
	};

	const renderGenres = (tags) => {
		return (
			<div>{tags?.genres ?
				<ul className="genre-list">
					{tags.genres.map((item, index) => <li><Link to={`/t/genre/${item.id}`}
																key={index}>{item.name}</Link></li>)}
				</ul>
				: null}</div>
		);
	};

	const handleAddToFavClick = () => {
		if (checkUserIsLogin()) {
			if (movieData?.userInteractions?.isFavorite) {
				removeFromFavorite(movieData?.baseDetails.programId).then(
					(res) => {
						if (res.status === 200 && res.data.code === 200) {
							getMovieDetails();
							setToastData(ShowToast(toastTypes.error, 'از لیست شخصی حذف شد'));
						}
					},
				);
			} else {
				addToFavorite(movieData?.baseDetails.programId).then(
					(res) => {
						if (res.status === 200 && res.data.code === 200) {
							getMovieDetails();
							setToastData(ShowToast(toastTypes.error, 'به لیست شخصی اضافه شد'));
						}
					},
				);
			}
		} else {
			if (window.innerWidth > 980) {
				setOpenRegisterDialog(true);
			} else {
				history.push('/register');
			}
		}
	};

	const renderLikeDislike = () => {
		return (
			<div className="like-dislike">
				<div className="like-info">
					<div className="like-percentage">
						<ImageGenerator src={heart} />
						<span>{movieData?.programInteractions?.likedPercent || 0}</span>
					</div>
				</div>
			</div>
		);
	};

	const handleLike = () => {
		if (checkUserIsLogin()) {
			likeProgram(movieData?.baseDetails.programId, 'movie', 'do_like').then(() => getMovieDetails()).catch(
				(error) => {
					setToastData(ShowToast(toastTypes.error, error.response.data.message));
				}
			);
		} else {
			if (window.innerWidth > 980) {
				setOpenRegisterDialog(true);
			} else {
				history.push('/register');
			}
		}
	};

	const handleDisLike = () => {
		if (checkUserIsLogin()) {
			dislikeProgram(movieData?.baseDetails.programId, 'movie', 'do_dislike').then(() => getMovieDetails()).catch(
				(error) => {
					setToastData(ShowToast(toastTypes.error, error.response.data.message));
				}
			);
		} else {
			if (window.innerWidth > 980) {
				setOpenRegisterDialog(true);
			} else {
				history.push('/register');
			}
		}
	};

	const renderRateUsers = () => {
		return (
			<>
				<div className="rate">
					<span className="d-flex flex-column justify-content-center" style={{ alignItems: 'center' }}>
						<ImageGenerator  src={logo}  />
						<span style={{color: '#8236FD', paddingTop: '5px', lineHeight: '18px'}}>
							{movieData?.programInteractions?.rate || 0}<span className="small">/5</span>
						</span>
					</span>
				</div>
			</>
		);
	};

	const updateInteraction = (newInteraction) => {
		const updatedData = {
			...movieData,
			userInteractions: {
				...movieData?.userInteractions,
				...newInteraction.userInteractions,
			},
			programInteractions: {
				...movieData?.programInteractions,
				...newInteraction.programInteractions,
			},
		};
		dispatch(movieDetailAction(updatedData, props.match.params.id));
	};

	const rateProgram = (rateNumber) => {
		rateAProgram(movieData.baseDetails.programId, rateNumber).then((res)=> {
			if (res.status === 200) {
				const interaction = {
					userInteractions: {
						disliked: res.data.data?.hasUserDisliked,
						liked: res.data.data?.hasUserLiked,
						rate: res.data.data?.userRate,
					},
					programInteractions: {
						dislikesCount: res.data.data?.programInteraction?.dislikesCount,
						likedPercent: res.data.data?.programInteraction?.likedPercent,
						likesCount: res.data.data?.programInteraction?.likesCount,
						rate: res.data.data?.programInteraction?.rate,
						rateCount: res.data.data?.programInteraction?.rateCount,
					}
				}
				updateInteraction(interaction)
			}
		})
	}

	const handleRateChange = (event, newValue) => {
		// setRateValue(newValue)
		if (!checkUserIsLogin()) {
			setIsRating(false)
			return;
		}
		rateProgram(newValue)
	};

	const goToRegister = () => <Button variant={'text'}
									   onClick={() => setOpenRegisterDialog(true)}>
		<span>ورود/ ثبت‌نام</span>
	</Button>;

	const renderProgramRate = () => {
		return(
			<>
				<div className="program-rate">
					<div>
						<div>
							امتیاز شما
						</div>
						{rateValue !== null && <Box>
						<span>
							{rateValue} از 5
						</span>
						</Box>}
					</div>
					<Box>
						<Rating
							style={{ marginTop: '5px' }}
							name="customized-empty"
							// readOnly={value}
							value={rateValue}
							onChange={handleRateChange}
							// onChangeActive={handleRateHover}
							icon={<StarIcon fontSize="inherit" style={{ color: '#FFC63C' }} />}
							emptyIcon={<StarBorderIcon fontSize="inherit" style={{ color: '#FFC63C' }} />}
						/>
					</Box>
					{!checkUserIsLogin() && !isRating && <Box className="rateMessage">
						<p>برای ثبت امتیاز ابتدا وارد شوید</p>
						{goToRegister()}
					</Box>}
				</div>
			</>
		)
	}

	const mobileView = () => {
		const handleStatus = () => {
			const handleAuthenticate = () => {
				if (window.innerWidth > 980) {
					setOpenRegisterDialog(true);
				} else {
					history.push('/register');
				}
			};

			if (movieData.metadata?.isFree !== false) {
				return <Button variant={'text'}
							   className="play">
					<Link to={`/player/${movieData?.baseDetails.programId}`}>
						<ImageGenerator src={play}
										isLazy={false}
										name={''} />
						تماشا
					</Link>
				</Button>;
			}
		};

		return (
			<div className="mobile-view">
				<div className="go-to-back">
					<Icon onClick={() => history.go(-1)} component={ChevronRight} />
				</div>
				<Breadcrumb
					style={{ padding: '10px 10px 10px 0', margin: '40px 16px -30px', backgroundColor: '#24202f87' }}
					firstItem={{ label: 'فیلم‌ها', path: '/' }}
					extraItem={{
						label: movieData?.metadata?.categories[0]?.name,
						path: `/t/category/${movieData?.metadata?.categories[0]?.id}/movies`,
					}}
					currentItem={movieData?.baseDetails?.title}
				/>
				<FixedCoverImage image={movieData.metadata.posterImageUrl}
								 className="background-image gradient-overly"/>
				<div className={`movie-info`}>
					<div>
						<FixedCoverImage image={movieData.baseDetails.image}
										 className="background-image-after-scroll"/>
						<div>
							<div className={classes.header_scrolling_before_title}>
								<span>{movieData.baseDetails.title}</span>
							</div>
							{isWebView && <div className="goToHome">
								<Link to={`/`}>
									<Icon component={ArrowForwardIos}/>
									صفحه اصلی
								</Link>
							</div>}
							<div className={`main-image ${classes.main_image}`}>
								<ImageGenerator src={movieData.baseDetails.image}
												name={movieData.baseDetails.title}/>
							</div>
							<div className={classes.first_view_title}>
								<span>{movieData.baseDetails.title}</span>
							</div>
							{renderGenres(movieData?.metadata)}
							{renderTags(movieData?.metadata)}
							<div className="operation-box">
								{/*<IconButton className={movieData?.userInteractions?.liked ? 'liked' : ''}*/}
								{/*			color={'primary'}*/}
								{/*			onClick={() => handleLike()}>*/}
								{/*	<ImageGenerator src={like}*/}
								{/*					isLazy={false}*/}
								{/*					name={''}/>*/}
								{/*</IconButton>*/}
								{/*<IconButton className={movieData?.userInteractions?.disliked ? 'disliked' : ''}*/}
								{/*			color={'primary'}*/}
								{/*			onClick={() => handleDisLike()}>*/}
								{/*	<ImageGenerator src={dislike}*/}
								{/*					isLazy={false}*/}
								{/*					name={''}/>*/}
								{/*</IconButton>*/}
								<Button className="share"
										onClick={toggleDrawer('bottom', true, 'share')}
										variant={'text'}>
									<ImageGenerator src={share}
													isLazy={false}
													name={''}/>
								</Button>
								<Button className={movieData?.userInteractions?.isFavorite ? 'added' : 'unAdded'}
										style={{width: '24px'}}
										onClick={handleAddToFavClick}
										variant={'text'}>
									<ImageGenerator src={favListAdd}
													isLazy={false}
													name={''}/>
								</Button>
							</div>
						</div>
					</div>
					<div className='download-box'>
						{handleStatus()}
						{  downloadLinks.length !=0 ?
							<>
								<Button variant={'text'}
										className="play">
									<div className='download-handler' onClick={()=> {
										setShowDownloadBox(!showDownloadBox);
									}}>
										<ImageGenerator src={download}
														isLazy={false}
														name={''}/>
										دانلود
									</div>
								</Button>
								<div className={`download-box-details accordion${showDownloadBox ? ' show' : ''}`}>
									<div className="Title_bar">
										<span className="title">دانلود</span>
										<div className='svgdownload'>
											<ImageGenerator src={Subtract}/>
										</div>
									</div>
									<div className="All_buttons">
										{downloadLinks.map((row) => (
											<div key={row.size}>
												<div className="donwload_text_row">
													<a href={row.link} target="_blank" className="qualities" key={row.size}>
														دانلود
													</a>
												</div>
												<p className="Allqualities">
													{row.size}
												</p>
											</div>

										))}
									</div>
								</div>
							</>
							:
							<>
							</>
						}
					</div>
					<Box className={scrollTop < 155 ? '' : classes.other_info_show}>
						<p className="description">{movieData.baseDetails?.description}</p>
						{renderProgramRate()}
						{checkHasCasts() ? <>
							<hr className="light-custom-hr"/>
							{renderCrews()}</> : null}
						{movieData?.metadata.actors.length ? <>
							<hr className="light-custom-hr"/>
							{renderActors()}</> : null}
						{relatedPrograms ?
							<>
								<hr className="light-custom-hr" />
								<ProgramCarousel data={relatedPrograms} type={'MOVIE'} />
							</> : ''
						}
						{fromDirector ?
							<>
								<hr className="light-custom-hr" />
								<ProgramCarousel data={fromDirector} type={'MOVIE'} />
							</> : ''
						}

						{movieData && movieData?.programInteractions?.comments && (
							<>
								<hr className="light-custom-hr" />
								<br/>
								<div style={{ position: 'relative', overflow: 'hidden', padding: '0 24px' }}>
									<div className="main-title">
										<span className="title">نظرات کاربران</span>
									</div>
									<Comments comments={movieData?.programInteractions?.comments}
											  programId={movieData?.baseDetails.programId} />
								</div>
							</>
						)}
					</Box>
				</div>
			</div>
		);
	};

	const desktopView = () => {
		return (
			<div className="desktop-view">
				{movieData && <Promotion renderLikeDislike={renderLikeDislike()}
										 typeProgram={'MOVIE'}
										 movieDetail={movieData}

										 handleAddToFav={handleAddToFavClick} />}

				{downloadLinks.length != 0 ?
					<>
						<div style={{position: 'relative', overflow: 'hidden'}}>
							<div className='main-title download-box-entry'>
								<span className='title'>دانلود</span>
							</div>
							<div className='download-box'>
								<div className='download-box-details show'>
									<div className='All_buttons'>

										{downloadLinks.map((row) => (
											<div key={row.size}>
												<div className='donwload_text_row'>
													<a href={row.link} target='_blank' className='qualities'
													   key={row.size}>
														<ImageGenerator src={download}
																		isLazy={false}
																		name={''}/>
														<span>
															دانلود با لینک مستقیم
														</span>
													</a>
												</div>
												<p className='Allqualities' >
													{row.size}
												</p>
											</div>

										))}
									</div>
								</div>

							</div>
						</div>
					</>
					:
					<></>
				}


				{checkHasCasts() ? <>
					{renderCrews()}</> : null}
				{movieData?.metadata.actors.length ? <>
					{renderActors()}</> : null}
				<hr className='light-custom-hr' />
				{relatedPrograms ?
					<><ProgramCarousel data={relatedPrograms} type={'MOVIE'} /> <hr className="light-custom-hr" /></>: ''
				}
				{fromDirector ?
					<ProgramCarousel data={fromDirector} type={'MOVIE'}/> : ''
				}
				{movieData && movieData?.programInteractions?.comments && (
					<div style={{ position: 'relative', overflow: 'hidden' }}>
						<div className="main-title">
							<span className="title">نظرات کاربران</span>
						</div>
						<Comments comments={movieData?.programInteractions?.comments} programId={movieData?.baseDetails.programId}/>
					</div>
				)}
				{(configApp?.titleEn === 'bebin' && !configApp?.sub_domain) && (<Footer></Footer>)}
			</div>
		);
	};

	const checkHasCasts = () => {
		return movieData?.metadata.directors.length || movieData?.metadata.writers.length || movieData?.metadata.producers.length
	}

	const renderCrews = () => {
		const crewMap = {};
		movieData?.metadata.writers.forEach((writer) => {
			if (!crewMap[writer.id]) {
				crewMap[writer.id] = { ...writer, roles: [] };
			}
			crewMap[writer.id].roles.push('نویسنده');
		});
		movieData?.metadata.directors.forEach((director) => {
			if (!crewMap[director.id]) {
				crewMap[director.id] = { ...director, roles: [] };
			}
			crewMap[director.id].roles.push('کارگردان');
		});
		movieData?.metadata.producers.forEach((producer) => {
			if (!crewMap[producer.id]) {
				crewMap[producer.id] = { ...producer, roles: [] };
			}
			crewMap[producer.id].roles.push('تهیه‌کننده');
		});

		// Convert the map back to an array
		const crewList = Object.values(crewMap);

		return (
			<div style={{ position: 'relative', overflow: 'hidden' }}>
				<div className="main-title">
					<span className="title">عوامل</span>
				</div>
				<div className="movie-involved casts">
					{
						crewList.map((crew, index) => (
							<div className="casts-box" key={index}>
								<Link to={`/t/crew/${crew.id}`} className="cast-item">
									<div style={{ textAlign: 'center' }}>
										<ImageGenerator
											src={crew?.imageUrl}
											isLazy={false}
											name={crew.farsiName || crew.name}
										/>
										<strong className="cast-name d-block">
											{crew.roles.join(' و ')}
										</strong>
										<span className="cast-name">{crew.farsiName || crew.name}</span>
									</div>
								</Link>
							</div>
						))
					}
				</div>
			</div>
		);
	};

	const renderActors = () => {
		return (
			<div style={{ position: 'relative', overflow: 'hidden' }}>
				<div className="main-title">
					<span className="title">بازیگران</span>
				</div>
				<div className="casts">
					<div className="casts-box">
						{movieData?.metadata.actors.map((actors, index) => <Link to={`/t/crew/${actors.id}`}
														  className="cast-item"
														  key={index}>
							<div>
								<ImageGenerator src={actors?.imageUrl}
												isLazy={false}
												name={actors.farsiName} />
								<span className="cast-name">{actors.farsiName}</span>
							</div>
						</Link>)}
					</div>
				</div>
			</div>
		);
	};

	const renderMovieData = () => {
		return (
			<div className='movie-page'>
				{isDesktop ? desktopView() : mobileView()}
			</div>
		);
	};

	const renderSchema = () => {
		return (
			<Helmet>
				<script type="application/ld+json">
					{JSON.stringify({
						"@context": "http://schema.org",
						"@type": "Movie",
						"name": movieData?.baseDetails?.title,
						...(movieData?.baseDetails?.englishTitle && {
							"alternateName": movieData?.baseDetails?.englishTitle
						}),
						"description": movieData?.baseDetails?.description,
						"image": movieData?.baseDetails?.image,
						"thumbnailUrl": movieData?.baseDetails?.smallImage,
						"mainEntityOfPage": window.location.origin + '/movies/' + movieData?.baseDetails?.programId,
						...(movieData?.metadata?.productionYear && {
							"productionYear": movieData?.metadata?.productionYear,
						}),
						...(movieData?.metadata?.movieLength.length > 0 && {
							"duration": movieData?.metadata?.movieLength
						}),
						"contentUrl": configApp?.media_id ? movieData?.link?.replace(/mediaId=[^&]*/, `mediaId=${configApp.media_id}`) : movieData?.link,
						...(movieData?.metadata?.genres.length > 0 && {
							"genre": movieData?.metadata?.genres.map(genre => genre.name)
						}),
						...(movieData?.metadata.directors.length > 0 && {
							"directors": movieData?.metadata.directors.map(actor => ({
								"@type": "Person",
								"name": actor.name
							}))
						}),
						...(movieData?.metadata?.actors.length > 0 && {
							"actor": movieData?.metadata?.actors.map(actor => ({
								"@type": "Person",
								"name": actor.name
							}))
						}),
						...(movieData?.programInteractions?.rate && {
							"aggregateRating": {
								"@type": "AggregateRating",
								"ratingValue": movieData?.programInteractions?.rate,
								"ratingCount": movieData?.programInteractions?.rateCount,
								"bestRating": 5,
								"worstRating": 1
							}
						})
					})}
				</script>
			</Helmet>
		);
	}

	return (
		<>
			{renderSchema()}
			<div className="movie-detail-container">
				{renderMovieData()}
				<SwipeableDrawer className="edit-profile-drawer"
								 anchor={'bottom'}
								 open={state['bottom']}
								 onClose={toggleDrawer('bottom', false)}
								 onOpen={toggleDrawer('bottom', true)}>
					{
						drawerType === 'share' ? <ShareBottomSheet data={movieData} /> : null
					}
				</SwipeableDrawer>

				<Toast toastList={toastData}
					   position={'top-right'}
					   autoDelete={true}
					   dismissTime={3000} />

				<AuthenticationDialogHandler openProfileDialog={openProfileDialog}
											 setOpenProfileDialog={setOpenProfileDialog}
											 openRegisterDialog={openRegisterDialog}
											 setOpenRegisterDialog={setOpenRegisterDialog} />
			</div>
		</>
	);
}

export default MovieDetailPage;
